import { Tooltip } from "@/components/ui/tooltip";
import { AppColors } from "@/styles/colors";
import { Flex, Text } from "@chakra-ui/react";
import { SendHorizontal } from "lucide-react";

interface Props {
  item: any;
  handleResend: (id: any) => void;
}

export const LoadedTaxesActions = ({ handleResend, item }: Props) => {
  return (
    <Tooltip
      openDelay={500}
      closeDelay={100}
      positioning={{ placement: "left" }}
      content={<Text fontSize="14px">Reenviar</Text>}
      contentProps={{
        css: {
          paddingX: "10px",
          "--tooltip-bg": AppColors.GREEN_PRIMARY,
        },
      }}
    >
      <Flex position="relative">
        <SendHorizontal
          cursor="pointer"
          onClick={() => handleResend(item?.id)}
          data-testid="loaded-taxes-actions-eye"
        />
      </Flex>
    </Tooltip>
  );
};
